import type { PaymentStatus } from '../../../types'
import { cn } from '../../../utils/cn'

/** Widths are fixed per label in the design rather than derived from padding. */
const STYLES: Record<PaymentStatus, string> = {
  paid: 'w-[47px] bg-dash-pill-paid',
  unpaid: 'w-[58px] bg-dash-pill-unpaid',
}

const LABELS: Record<PaymentStatus, string> = {
  paid: 'Paid',
  unpaid: 'Unpaid',
}

type PaymentBadgeProps = {
  status: PaymentStatus
}

export const PaymentBadge = ({ status }: PaymentBadgeProps) => (
  <span
    className={cn(
      'flex h-[26px] shrink-0 items-center justify-center whitespace-nowrap rounded-[12px] font-host text-[14px] font-normal leading-normal text-dash-pill-ink',
      STYLES[status],
    )}
  >
    {LABELS[status]}
  </span>
)
